import React from 'react';
import css from './css.module.less';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ActionType } from 'src/types/common/common';

//import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getLocationSelector,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onLocationSelectorOptionChange,
  onLocationSelectorTitleChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

import { Input, Text } from '@/src/components/Antd';
import DeleteButton from 'src/components/Buttons/DeleteButton';
import DragNDropColumns from 'src/components/DragNDropColumns';

import LinkLibrary from '@/src/constrains/LinkLibrary';
import { LinkModuleType } from '@/src/types/common/linkType';
import { useI18n } from 'src/hooks/useRouterChange';
import { generateFooterLocationOption } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import {
  errKey,
  validateLocationSelector,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
import { store } from 'src/store';
import {
  generalValuePickerAccordingLanguage,
  getI18nFromGeneral,
  i18nGet,
} from 'src/tools/tools';

const LocationSelector = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _params: any = useParams();
  const { contentUuid } = _params;
  const linkSet = {
    linkTypeFilter: [LinkModuleType.LinkLibrary],
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
  };

  const d = useDispatch();
  const { data, specificError, isPrimary } = props;
  //console.log('specificError', specificError);
  const titleErr = specificError[errKey.locationSelectorTitle];
  //console.log('titleErr', titleErr);
  const { title, locationOptions } = data || {};
  // console.log('data1', data);
  const handleOnChildGenerate = (data, index) => {
    const { title, linkLibrary, draggableId } = data || {};
    const titleErr =
      specificError[`${errKey.locationSelectorOptionTitle}${draggableId}`];
    //console.log('data2', data);
    const linkErr =
      specificError[`${errKey.locationSelectorOptionLink}${draggableId}`];

    return (
      <div className={css.cardContainer}>
        <ItemWrapper
          //titleContainerClassName={css.titleContainer}
          rightPart={
            isPrimary && (
              <DeleteButton
                //disable={disableDelete}
                onClick={() => {
                  const type = ActionType.delete;
                  d(
                    onLocationSelectorOptionChange({
                      index,
                      type,
                    }),
                  );
                }}
                className={css.deleteIcon}
              />
            )
          }
          title={
            <div className={css.deleteTitle}>
              <Text>
                {getI18n('salesChannelContent.index.locationOptionTitle')}*
              </Text>
            </div>
          }>
          <Input
            error={(titleErr || []).length > 0}
            help={(titleErr || []).join(' ')}
            size='large'
            value={title}
            maxLength={100}
            onChange={(title) => {
              const type = ActionType.modify;
              d(
                onLocationSelectorOptionChange({
                  type,
                  target: { title },
                  index,
                }),
              );
            }}
          />
        </ItemWrapper>
        {isPrimary && (
          <LinkLibrary
            error={(linkErr || []).join(' ')}
            data={linkLibrary}
            onChange={(linkLibrary) => {
              const type = ActionType.modify;
              d(
                onLocationSelectorOptionChange({
                  type,
                  target: { linkLibrary },
                  index,
                }),
              );
            }}
            linkSet={linkSet}
          />
        )}
      </div>
    );
  };

  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const type = ActionType.reorder;
    d(
      onLocationSelectorOptionChange({
        type,
        from: oldIndex,
        to: newIndex,
      }),
    );
  };

  const handleOnAdd = () => {
    const target = generateFooterLocationOption();
    const type = ActionType.add;
    d(
      onLocationSelectorOptionChange({
        type,
        target,
      }),
    );
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n(
            'salesChannelContent.index.locationSelectorTitle',
          )}*`}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            error={(titleErr || []).length > 0}
            help={(titleErr || []).join(' ')}
            maxLength={100}
            size='large'
            value={title}
            onChange={(title) => {
              d(onLocationSelectorTitleChange(title));
            }}
          />
        </ItemWrapper>
      </Section>
      <DragNDropColumns
        disabled={!isPrimary}
        hideAdd={!isPrimary}
        hideTitle
        childGenerate={handleOnChildGenerate}
        data={locationOptions}
        droppableId={'salesChannelContentFooterLocationSelector'}
        onSort={handleOnSort}
        // hideAdd={hideAdd}
        onAdd={handleOnAdd}
        addText={`+ ${getI18n('salesChannelContent.index.addLocationOption')}`}
      />
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(LocationSelector, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.locationSelector,
  getContent: getLocationSelector,
  title: getI18nFromGeneral('general.hOCTitle.locationSelector'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  getSubmitStamp,
  expandOffset: 0,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateLocationSelector(x, isPrimary);
  },
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          const text = generalValuePickerAccordingLanguage({
            cn: '位置',
            hk: '位置',
            gb: 'Location',
          });

          store.dispatch(onLocationSelectorTitleChange(text));
          // const dD = generateFooterStyle();
          // store.dispatch(onFooterStyleChange(dD));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
